$(document).on("ready page:load", function() {
  $('.user-registration-form').submit(function(event) {
    $(this).find('[type=submit]').hide();
    $('.submit-button-spinner').show();
  });

  $('.edit-user-form').submit(function(event) {
    if (!$("#terms").is(':checked')) {
      alert("Please click to accept our Terms and Conditions.")
      return false;
    }
  });

  $(document).on("click", "#close-form" , function() {
    if($(".designee-form-on-signup")[0] == undefined) {
      $(".add-designee-form").html('');
      $(".add-designee-btn").removeClass("d-none")
    } else {
      $(".designee-form-on-signup").addClass("d-none");
      $(".designee-checkbox-on-signup").removeClass("d-none");
      $(".administrator-checkbox-on-signup").removeClass("d-none");
      $("#is_designee")[0].checked = false
    }
  });

  $('.tooltipster').tooltipster({
    functionInit: function(instance, helper){
      var content = $(helper.origin).find('.tooltip_content').detach();
      instance.content(content);
    },
    interactive: true,
    theme: 'tooltipster-light',
    trigger: 'click',
    maxWidth: 300
  });

  // Open confirmation modal for Unapproved Operators
  $('.delete_operator_btn').click(function() {
    event.preventDefault();
    link = $(this).attr("href");
    $("#confirmation_modal_link").attr("href", link)
    $("#myModal").modal()
  });
});

function open_add_designee_form(add_designee_toggle) {
  $.ajax({
    type: 'GET',
    url: "/users/new_designee"
  });
}
